import { useState, useCallback } from 'react';
import { getReportDetail } from '../api/reportsService';
import { ReportDetailResponse } from '../types/interfaces';

export const useReportDetailsNew = (reportId: string) => {
  const [data, setData] = useState<ReportDetailResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchReportDetails = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const detail = await getReportDetail(reportId);
      setData(detail);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [reportId]);

  return { data, loading, error, fetchReportDetails };
};
